module.exports = __webpack_public_path__ + "img/UTCAMP-4.0ee53325.jpg";